(function () {
  if (window.__ctrTextInit) return;
  window.__ctrTextInit = true;

  function getSelectedPurchaseOption(scope) {
    var root = scope || document;
    var selected =
      root.querySelector('[data-ctr-purchase-option]:checked') ||
      root.querySelector('[data-legacy-purchase-option]:checked');
    return selected ? selected.value : null;
  }

  function syncTextBlocks(scope) {
    var searchRoot = scope || document;
    var blocks = searchRoot.querySelectorAll('[data-ctr-text]');
    if (!blocks.length && searchRoot.matches && searchRoot.matches('[data-ctr-text]')) {
      blocks = [searchRoot];
    }

    blocks.forEach(function (block) {
      var sectionRoot = block.closest('.shopify-section') || document;
      var selectedOption = getSelectedPurchaseOption(sectionRoot);
      var showFor = block.getAttribute('data-ctr-show-for') || 'both';
      var visible = !selectedOption || showFor === 'both' || showFor === selectedOption;
      block.classList.toggle('is-hidden', !visible);
    });
  }

  function init(scope) {
    syncTextBlocks(scope || document);
  }

  document.addEventListener('change', function (event) {
    var target = event.target;
    if (!target || !target.matches) return;
    if (!target.matches('[data-ctr-purchase-option], [data-legacy-purchase-option]')) return;
    syncTextBlocks(target.closest('.shopify-section') || document);
  });

  document.addEventListener('DOMContentLoaded', function () {
    init(document);
  });

  window.addEventListener('pageshow', function () {
    init(document);
  });

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
    document.addEventListener('shopify:block:select', function (event) {
      init(event.target);
    });
    document.addEventListener('shopify:section:select', function (event) {
      init(event.target);
    });
  }
})();
